import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex);


const state = {
  count: {},
};

const mutations = {
  /* eslint no-shadow: "off" */
  INCREMENT(state, amount) {
    /* eslint no-param-reassign: "off" */
    if (!state.count.count) {
      state.count.count = 0;
    }
    state.count.count = state.count.count + amount;
  },
};

export default new Vuex.Store({
  state,
  mutations,
});



/** WEBPACK FOOTER **
 ** ./src/vuex/store.js
 **/